import { Controller } from "@hotwired/stimulus"

// The rooms list: marks the current room. Rows are replaced live over the
// user's stream, so the active state is re-applied after every change.
export default class extends Controller {
  static targets = ["list", "row", "onlineCount"]
  static values = { current: Number, onlineLabels: Object }

  connect() {
    this.mark()
    this.syncBody()
    this.observer = new MutationObserver(() => { this.mark(); this.countOnline() })
    if (this.hasListTarget) this.observer.observe(this.listTarget, { childList: true, subtree: true })
  }

  disconnect() {
    this.observer?.disconnect()
    document.body.classList.remove("in-chat-room")
  }

  // Mobile: one pane at a time. Back reveals the rooms/people list without
  // navigating (which would redirect to a room again).
  showList() {
    this.element.classList.remove("chat--room")
    this.syncBody()
  }

  showRoom() {
    this.element.classList.add("chat--room")
    this.syncBody()
  }

  // A room pane on a phone goes full screen: the body flag hides the app bar
  // and the bottom tab bar (see the CSS).
  syncBody() {
    document.body.classList.toggle("in-chat-room", this.element.classList.contains("chat--room"))
  }

  // "3 online" under the People heading, recounted when a dot is replaced.
  countOnline() {
    if (!this.hasOnlineCountTarget || !this.hasListTarget) return
    const n = this.listTarget.querySelectorAll(".chat-row .chat-presence--online").length
    const labels = this.onlineLabelsValue
    const label = n === 0 ? labels.zero : n === 1 ? labels.one : labels.other
    if (!label) return
    const text = label.replace("%{count}", n)
    // Only write on change: the counter lives inside the observed list.
    if (this.onlineCountTarget.textContent !== text) this.onlineCountTarget.textContent = text
  }

  mark() {
    for (const row of this.rowTargets) {
      const active = Number(row.dataset.roomId) === this.currentValue
      row.classList.toggle("chat-row--active", active)
      if (active) row.setAttribute("aria-current", "page")
      else row.removeAttribute("aria-current")
    }
  }
}
